import { Outlet, useLocation } from 'react-router-dom'
import { ButtonIcon, ModalProps, ModalRush } from '@/ui'
import { XClose } from '@/icons'
import { ReactNode, useEffect, useState } from 'react'
import { cn } from '@dashboard/ui'

interface SettingsLayoutProps extends ModalProps {
  sidebar?: ReactNode
}

export const SettingsLayout = (props: SettingsLayoutProps) => {
  const [hasFormPanel, setHasFormPanel] = useState<boolean>(false)
  let location = useLocation()

  useEffect(() => {
    const outlet = document.querySelector('[data-id="fixed-form-panel"]')
    if (outlet) {
      setHasFormPanel(true)
    } else {
      setHasFormPanel(false)
    }
  }, [location])

  return (
    <ModalRush {...props} className="relative p-0">
      <ButtonIcon
        className="fixed right-5 top-9 z-30"
        size="xs"
        variant="outline"
        color="secondary"
        onClick={props.onClose}
      >
        <XClose />
      </ButtonIcon>
      <div className="flex size-full min-w-[800px] ">
        {props.sidebar && <div className="z-20 h-full">{props.sidebar}</div>}
        <div className={cn('w-full items-center overflow-y-auto', hasFormPanel ? 'pb-20' : '')}>
          <div
            className={cn(
              'mx-auto flex w-full max-w-[1144px] flex-col gap-4 px-4 pt-12 2xl:pt-3',
              hasFormPanel ? '' : 'h-full pb-3',
            )}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </ModalRush>
  )
}
